import React from 'react';

const Titles = (props) => {

    return(
        <div>
            <h1>Weather Finder</h1>
            <p>Find out temperature, conditions and more...</p>
        </div>
    );

}

export default Titles;